import { lazy } from "react";
import { AppRoute } from "shared/types/AppRoute";

const OperationsDashboard = lazy(
  () => import("../pages/DashboardOperationsPage"),
);
const DirectorDashboard = lazy(() => import("../pages/DashboardDirectorPage"));
const CollaboratorDashboard = lazy(
  () => import("../pages/DashboardCollaboratorPage"),
);
const TimeSheet = lazy(() => import("../pages/TimeSheetPage"));
const ManagerHours = lazy(() => import("../pages/HoursManagementPage"));
const WorkSessionRequest = lazy(
  () => import("../pages/WorkSessionRequestsPage"),
);
const ProjectsPage = lazy(() => import("../pages/ProjectsPage"));
const ProjectPage = lazy(() => import("../pages/ProjectPage"));

export const architectureRoutes: AppRoute[] = [
  {
    path: "manager",
    component: OperationsDashboard,
    domain: "architecture",
    requiredPermissions: ["architecture.dashboard.operations.full"],
    meta: {
      sidebar: {
        label: "Operations Dashboard",
        iconName: "Operations Manager",
      },
    },
  },
  {
    path: "director/dashboard",
    component: DirectorDashboard,
    domain: "architecture",
    requiredPermissions: ["architecture.dashboard.director.view"],
    meta: {
      sidebar: {
        label: "Dashboard Director",
        iconName: "Dashboard Director",
      },
    },
  },
  {
    path: "director/collaborator/:uuid",
    component: CollaboratorDashboard,
    domain: "architecture",
    requiredPermissions: ["architecture.dashboard.director.view"],
    requiredPermissionScopesAny: [
      {
        permission: "architecture.workSessions.read",
        scopes: ["hierarchy", "all"],
      },
    ],
  },
  {
    path: "collaborator",
    component: CollaboratorDashboard,
    domain: "architecture",
    requiredPermissions: ["architecture.dashboard.collaborator.view"],
    meta: {
      sidebar: {
        label: "Dashboard Collaborator",
        iconName: "Dashboard Collaborator",
      },
    },
  },
  {
    path: "collaborator/:uuid",
    component: CollaboratorDashboard,
    domain: "architecture",
    requiredPermissions: ["architecture.dashboard.collaborator.view"],
  },
  {
    path: "collaborator/timesheet",
    component: TimeSheet,
    domain: "architecture",
    requiredPermissions: ["architecture.workSessions.create"],
    meta: {
      sidebar: {
        label: "Timesheet",
        iconName: "Timesheet",
      },
    },
  },
  {
    path: "manager/hours/:uuid?",
    component: ManagerHours,
    domain: "architecture",
    requiredPermissionScopesAny: [
      {
        permission: "architecture.workSessions.read",
        scopes: ["hierarchy", "all"],
      },
    ],
    meta: {
      sidebar: {
        label: "Hours Manager",
        iconName: "Hours Manager",
      },
    },
  },
  {
    path: "collaborator/worksessions_request/:uuid?",
    component: WorkSessionRequest,
    domain: "architecture",
    requiredPermissionsAny: [
      "architecture.requests.read",
      "architecture.requests.create",
    ],
    meta: {
      sidebar: {
        label: "Work sessions request",
        iconName: "Worksession Requests",
      },
    },
  },
  {
    path: "projects",
    component: ProjectsPage,
    domain: "architecture",
    requiredPermissions: ["architecture.projects.read"],
    meta: {
      sidebar: {
        label: "Projects",
        iconName: "Users",
        hidden: true,
      },
    },
  },
  {
    path: "projects/:id",
    component: ProjectPage,
    domain: "architecture",
    requiredPermissions: ["architecture.projects.read"],
    meta: {
      sidebar: {
        label: "Project",
        iconName: "Users",
        hidden: true,
      },
    },
  },
];
